import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from 'services/api';

function saApi() {
  return { headers: { Authorization: `Bearer ${localStorage.getItem('gss_sa_token')}` } };
}

const STATUTS = [
  { value: 'nouveau', label: 'Nouveau', color: 'var(--gss-info)' },
  { value: 'contacte', label: 'Contacté', color: 'var(--gss-warning)' },
  { value: 'converti', label: 'Converti', color: 'var(--gss-success)' },
  { value: 'sans_suite', label: 'Sans suite', color: 'var(--gss-text-light)' },
];

function statutCfg(val) {
  return STATUTS.find(s => s.value === val) || STATUTS[0];
}

export default function SuperAdminDemandes() {
  const [demandes, setDemandes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(null);

  const load = () => {
    api.get('/super-admin/demandes-demo', saApi())
      .then(r => setDemandes(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  };
  useEffect(load, []);

  const changeStatut = async (id, statut) => {
    try {
      await api.patch(`/super-admin/demandes-demo/${id}`, { statut }, saApi());
      setDemandes(prev => prev.map(d => d.id === id ? { ...d, statut } : d));
    } catch { /* silently fail */ }
  };

  const total = demandes.length;
  const nouveaux = demandes.filter(d => d.statut === 'nouveau').length;
  const contactes = demandes.filter(d => d.statut === 'contacte').length;
  const convertis = demandes.filter(d => d.statut === 'converti').length;

  return (
    <div style={S.page}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div>
          <Link to="/super-admin" style={{ color: 'var(--gss-text-light)', fontSize: 12, textDecoration: 'none' }}>Dashboard</Link>
          <span style={{ color: 'var(--gss-text-light)', margin: '0 8px' }}>/</span>
          <span style={{ color: 'var(--gss-text)', fontSize: 14, fontWeight: 700 }}>Demandes de démo & devis</span>
        </div>
      </div>

      {/* KPIs */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 240px), 1fr))', gap: 16, marginBottom: 24 }}>
        <KPI label="Total demandes" value={total} color="var(--gss-text)" />
        <KPI label="Nouveaux" value={nouveaux} color="var(--gss-info)" />
        <KPI label="Contactés" value={contactes} color="var(--gss-warning)" />
        <KPI label="Convertis" value={convertis} color="var(--gss-success)" />
      </div>

      {/* Tableau */}
      <div style={S.card}>
        <div className="gss-table-wrap">
          <table style={{ width: '100%', minWidth: 900, borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                {['Date', 'Objet', 'Offre', 'Effectif', 'Nom', 'Entreprise', 'Email', 'Téléphone', 'Statut', ''].map(h =>
                  <th key={h} style={S.th}>{h}</th>
                )}
              </tr>
            </thead>
            <tbody>
              {demandes.map(d => {
                const sc = statutCfg(d.statut);
                const isExpanded = expanded === d.id;
                return (
                  <tr key={d.id} style={{ cursor: d.message ? 'pointer' : 'default', background: isExpanded ? 'var(--gss-border)' : 'transparent' }}
                    onClick={() => d.message && setExpanded(isExpanded ? null : d.id)}>
                    <td style={{ ...S.td, fontSize: 11, color: 'var(--gss-text-light)', whiteSpace: 'nowrap' }}>
                      {new Date(d.created_at).toLocaleDateString('fr-FR')}<br />
                      <span style={{ fontSize: 10 }}>{new Date(d.created_at).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}</span>
                    </td>
                    <td style={{ ...S.td, fontSize: 11 }}>{d.objet}</td>
                    <td style={S.td}>
                      {d.offre ? (
                        <span style={{ padding: '2px 8px', borderRadius: 20, fontSize: 10, fontWeight: 700,
                          background: 'var(--gss-red-bg, rgba(139,26,26,0.08))', color: 'var(--gss-red)' }}>{d.offre}</span>
                      ) : <span style={{ color: 'var(--gss-text-light)', fontSize: 11 }}>—</span>}
                    </td>
                    {/* ⓘ L effectif declare par le demandeur. Il etait ENVOYE par le
                        formulaire et jete par le serveur : ni valide, ni stocke, ni
                        affiche. Un tiret dit « non precise » ; il ne dit plus
                        « la colonne n existe pas ». */}
                    <td style={{ ...S.td, fontSize: 11, whiteSpace: 'nowrap' }}>
                      {d.nombre_agents || <span style={{ color: 'var(--gss-text-light)' }}>—</span>}
                    </td>
                    <td style={{ ...S.td, fontWeight: 600, fontSize: 12, color: 'var(--gss-text)' }}>{d.nom}</td>
                    <td style={{ ...S.td, fontSize: 11 }}>{d.entreprise}</td>
                    <td style={S.td}>
                      <a href={`mailto:${d.email}`} style={{ color: 'var(--gss-red)', fontSize: 11, textDecoration: 'none' }}
                        onClick={e => e.stopPropagation()}>{d.email}</a>
                    </td>
                    <td style={{ ...S.td, fontSize: 11, color: 'var(--gss-text-light)' }}>{d.telephone || '—'}</td>
                    <td style={S.td} onClick={e => e.stopPropagation()}>
                      <select
                        value={d.statut}
                        onChange={e => changeStatut(d.id, e.target.value)}
                        style={{
                          padding: '3px 8px', borderRadius: 6, fontSize: 10, fontWeight: 700,
                          border: '1px solid var(--gss-border-strong)',
                          background: `${sc.color}18`, color: sc.color,
                          cursor: 'pointer', outline: 'none',
                        }}
                      >
                        {STATUTS.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
                      </select>
                    </td>
                    <td style={S.td}>
                      {d.message && (
                        <span style={{ fontSize: 10, color: 'var(--gss-text-light)' }} title="Voir le message">
                          {isExpanded ? '▲' : '▼'}
                        </span>
                      )}
                    </td>
                  </tr>
                );
              })}
              {demandes.length === 0 && !loading && (
                <tr><td colSpan={9} style={{ ...S.td, textAlign: 'center', color: 'var(--gss-text-light)', padding: 40 }}>
                  Aucune demande pour le moment
                </td></tr>
              )}
            </tbody>
          </table>
        </div>
        {/* Message expandable */}
        {expanded && (() => {
          const d = demandes.find(x => x.id === expanded);
          if (!d?.message) return null;
          return (
            <div style={{
              margin: '0 16px 16px', padding: 12, borderRadius: 8,
              background: 'var(--gss-bg)', border: '1px solid var(--gss-border)',
              fontSize: 12, color: 'var(--gss-text-secondary)', lineHeight: 1.6, whiteSpace: 'pre-wrap',
            }}>
              <div style={{ fontSize: 10, color: 'var(--gss-text-light)', marginBottom: 6, textTransform: 'uppercase', letterSpacing: 1 }}>Message</div>
              {d.message}
            </div>
          );
        })()}
        {loading && <p style={{ color: 'var(--gss-text-light)', padding: 20 }}>Chargement...</p>}
      </div>
    </div>
  );
}

function KPI({ label, value, color }) {
  return (
    <div style={{
      background: 'var(--gss-white)', borderRadius: 12, padding: '16px 20px',
      border: '1px solid var(--gss-border)',
    }}>
      <div style={{ fontSize: 11, color: 'var(--gss-text-light)', marginBottom: 4 }}>{label}</div>
      <div style={{ fontSize: 28, fontWeight: 800, color }}>{value}</div>
    </div>
  );
}

const S = {
  page: { padding: 'clamp(12px, 3vw, 24px)', maxWidth: 1400, margin: '0 auto', width: '100%', boxSizing: 'border-box' },
  card: { background: 'var(--gss-white)', borderRadius: 12, padding: 20, border: '1px solid var(--gss-border)', minWidth: 0 },
  th: {
    textAlign: 'left', padding: '8px 10px', fontSize: 10, fontWeight: 700,
    color: 'var(--gss-text-light)', textTransform: 'uppercase', letterSpacing: 0.5,
    borderBottom: '2px solid var(--gss-border)',
  },
  td: { padding: '10px 10px', borderBottom: '1px solid var(--gss-border)', color: 'var(--gss-text-secondary)', fontSize: 12 },
};
